import { createApp } from "vue";
import App from "./App.vue";
// import { echo } from"@/core/services/Echo"
//import Datepicker from 'vue3-date-time-picker';
//import 'vue3-date-time-picker/dist/main.css'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { Actions } from "@/store/enums/StoreEnums";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "@/router/clean";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
//imports for app initialization
import ApiService from "@/core/services/ApiService";
import BusProxyService from "@/core/services/BusProxyService";
import DropZone from "dropzone-vue";
import { redirectPathStyleMaxiDeepLinkToHash } from "@/core/helpers/maxiVehicleLink";

import "dropzone-vue/dist/dropzone-vue.common.css";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";


import "@/core/plugins/prismjs";
import "bootstrap";

// MaxiPublica usa /car?mpId=...; el router es hash → redirigir antes de montar.
if (redirectPathStyleMaxiDeepLinkToHash()) {
  // location.replace ya se disparó; evitar montar la app en la URL path-style.
} else {
bootstrapApp();
}

function bootstrapApp() {
const app = createApp(App);

app.mixin({
    methods: {
        checkPermissions: function (user, module, permission) {
            store
            .dispatch(Actions.CHECK_PERMISSIONS, {uuid:user, "modulo":module, 'permiso':permission})
            .then((response) => {
                return response
            })
            .catch(() => {
                return false
            });
        },
    },
})

app.directive('resize', {
    mounted(el, binding) {
        const onResizeCallback = binding.value;
        const resizeHandler = () => {
            
        const width = el.getBoundingClientRect().width;
        const height = el.getBoundingClientRect().height;
        onResizeCallback({ width, height });
      };
      window.addEventListener('resize', resizeHandler);
      el._onResize = resizeHandler;
    },
    beforeUnmount(el) {
      window.removeEventListener('resize', el._onResize);
    }
  });

app.use(store);
app.use(router);
app.use(DropZone);
app.use(ElementPlus);
app.component('Datepicker', Datepicker);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

// Iniciar el servicio de proxy del BUS si está habilitado
// Este servicio permite que el frontend actúe como proxy para peticiones al BUS de Toyota
// cuando el backend está en un clúster con firewall que bloquea las salidas
if (process.env.VUE_APP_ENABLE_BUS_PROXY === 'true') {
  console.log('[App] Iniciando servicio de proxy del BUS');
  BusProxyService.startPolling();
}
// GTM-5GH8CNCS is loaded once in public/index.html. Public views use its existing dataLayer.
// app.config.globalProperties.$echo = echo;
app.use(i18n);
app.mount("#app");
}
